import { createContext, useContext, useState } from "react";

const InterviewSettingsContext = createContext();

export default function InterviewSettingContextProvider({ children }) {
  const [newCategoryAdded, setNewCategoryAdded] = useState(false);
  const [newSubcategoryAdded, setNewSubCategoryAdded] = useState(false);

  return (
    <InterviewSettingsContext.Provider
      value={{
        newCategoryAdded,
        setNewCategoryAdded,
        newSubcategoryAdded,
        setNewSubCategoryAdded
      }}
    >
      {children}
    </InterviewSettingsContext.Provider>
  );
}

export function useInterviewSettingsContext() {
  const context = useContext(InterviewSettingsContext);
  return context;
}
